/* KIJIN ご相談の窓口（sections/kijin-contact.liquid）2026-09-24
   「種類を選ぶと開く」。規則は見本（top/page.js・price_A/shared-contact.js）と同じ。
   閉じている欄の入力は disabled にして送らない。送信は止めない（Shopify 標準の contact フォーム）。 */
(function () {
  'use strict';
  var RULES = {
    '': [],
    '気軽に相談したい': ['kind_heading', 'kind_checks', 'body'],
    '見積もりをしてほしい': ['kind_heading', 'kind_checks', 'body', 'attach'],
    '採寸に来てほしい': ['kind_heading', 'kind_checks', 'body', 'addr'],
    'メディア・取材等': ['body'],
    'その他': ['body']
  };
  var KEYS = ['kind_heading', 'kind_checks', 'body', 'addr', 'attach'];

  /* 2026-11-03 送信を押して足りない欄があったら、その欄を画面の真ん中へ寄せる（動きなし）。
     上の固定の帯の裏に欄が隠れて、知らせがどの欄のことか分からなくなるため。なめらかに動かすと知らせが消える */
  function centerFirstInvalid(scope) {
    if (!scope || scope.getAttribute('data-kj-invalid-ready') === '1') return;
    scope.setAttribute('data-kj-invalid-ready', '1');
    var busy = false;
    scope.addEventListener('invalid', function (e) {
      if (busy) return;
      busy = true;
      setTimeout(function () { busy = false; }, 0);
      try {
        e.target.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'instant' });
      } catch (err) {
        e.target.scrollIntoView(false);
      }
    }, true);
  }

  function setup(root) {
    var select = root.querySelector('[data-mf-kind]');
    if (!select || select.getAttribute('data-mf-ready') === '1') return;
    select.setAttribute('data-mf-ready', '1');
    centerFirstInvalid(root);
    var blocks = {};
    KEYS.forEach(function (k) { blocks[k] = root.querySelector('[data-mf="' + k + '"]'); });

    function sync() {
      var show = RULES[select.value] || [];
      KEYS.forEach(function (k) {
        var el = blocks[k];
        if (!el) return;
        var hide = show.indexOf(k) < 0;
        el.hidden = hide;
        var fields = el.querySelectorAll('input, textarea, select');
        for (var i = 0; i < fields.length; i++) fields[i].disabled = hide;
      });
    }

    select.addEventListener('change', sync);
    /* 戻るボタンなどで、ブラウザが選択を復元したときも合わせる */
    window.addEventListener('pageshow', sync);
    sync();
  }

  function start() {
    var roots = document.querySelectorAll('.kj-contact');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  /* テーマエディタで段を差し替えたとき */
  document.addEventListener('shopify:section:load', start);
}());
